import {
    Autocomplete,
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    IconButton,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { getDashboardFielderClaim, getDashboardMileageComparison } from '../../dashbord/dashboard.api';
import CustomDatePicker from '../../../shared/customDatePicker/CustomDatePicker';
import { formatName } from '../../../shared/utils';
import { Close, Description, Search } from '@mui/icons-material';
import Papa from 'papaparse';
import { getAccountFielder } from '../../account/account.api';
import { setParameterGetData } from '../../project/project.reducer';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ImagePreview from '../../../shared/ImagePreview';

export default function OntimeMileageComparison() {
    const dispatch = useDispatch<any>();

    const { dataMileageComparison } = useSelector((state: RootState) => state.dashboard);
    const { dataFielderList } = useSelector((state: RootState) => state.account);

    // delaying input search
    const [timer, setTimer] = useState(setTimeout(() => {}, 1000));

    const [filter, setFilter] = useState<string | undefined>('');
    const [searchText, setSearchText] = useState<string>('');
    const [dateStart, setDateStart] = useState(moment().add(-7, 'days').format('YYYY-MM-DD'));
    const [dateEnd, setDateEnd] = useState(moment().format('YYYY-MM-DD'));
    const [fielderIdSelected, setFielderIdSelected] = useState<string | undefined>(undefined);

    const [imageSelected, setImageSelected] = useState<Array<{ label: string; url: string }> | null>(null);
    const [imageSelectedIndex, setImageSelectedIndex] = useState<number | null>(null);

    useEffect(() => {
        dispatch(getAccountFielder());
    }, [dispatch]);

    useEffect(() => {
        dispatch(
            getDashboardMileageComparison({
                filterStartDate: dateStart,
                filterEndDate: dateEnd,
                fielderId: fielderIdSelected || undefined
            })
        );
    }, [dispatch, dateStart, dateEnd, fielderIdSelected]);

    // const handleExportCsv = () => {
    //     const csvData = dataManagerLogs.map((item) => ({
    //         Project: item.project,
    //         Request: item.fieldingRequest,
    //         AssignedFielder: item.assignedFielder,
    //         FieldingType: item.fieldingType,
    //         Poles: item.poles,
    //         Frontyard: item.frontyard,
    //         Backyard: item.backyard,
    //         NoAccessPoles: item.noAccessPole,
    //         Underground: item.underground,
    //         structures: item.structures,
    //         NoAccessStructures: item.noAccessStructures,
    //         StructuresNotInField: item.structuresNotInField,
    //         CompleteDate: item.date,
    //     }));
    //     const csvString = Papa.unparse(csvData, {header: true});
    //     const blob = new Blob([csvString], {type: 'text/csv;charset=utf-8;'});
    //     const url = URL.createObjectURL(blob);
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.download = `manager logs ${moment(dateStart).format('YYYY-MM-DD')} - ${moment(dateEnd).format('YYYY-MM-DD')}.csv`;
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // }

    const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
        clearTimeout(timer);
        setTimer(
            setTimeout(() => {
                setFilter(e.target.value);
            }, 1000)
        );
    };

    const onAttachmentClicked = (attachmentUrlStart: string, attachmentUrlEnd: string, index: number) => {
        // label + file extension
        const attachmentStart = attachmentUrlStart !== null && attachmentUrlStart !== '' ? { label: `Start Attachment${attachmentUrlStart.slice(-4)}`, url: attachmentUrlStart } : null;
        const attachmentEnd = attachmentUrlEnd !== null && attachmentUrlEnd !== '' ? { label: `End Attachment${attachmentUrlEnd.slice(-4)}`, url: attachmentUrlEnd } : null;
        setImageSelected([attachmentStart, attachmentEnd].filter(Boolean) as { label: string; url: string }[]);
        setImageSelectedIndex(index);
    };

    console.log('imageSelected', imageSelected);

    return (
        <Card variant="outlined">
            <CardHeader
                sx={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}
                title="Mileage Comparison"
                action={
                    <Box display={'flex'} flexWrap={'wrap'} justifyContent={'flex-end'} gap={1}>
                        <Autocomplete
                            sx={{ width: 200 }}
                            options={dataFielderList}
                            getOptionLabel={(value: { id: string; fullName: string }) => formatName(value.fullName)}
                            onChange={(e, value) => setFielderIdSelected(value?.id || '')}
                            value={dataFielderList.find((data) => data.id === fielderIdSelected)}
                            renderInput={(params) => <TextField {...params} label="Filter Fielder" />}
                        />
                        {/* <TextField
                            label="Project"
                            sx={{ width: 200 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                ),
                                endAdornment:
                                    searchText !== '' ? (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => {
                                                    setFilter('');
                                                    setSearchText('');
                                                }}
                                            >
                                                <Close />
                                            </IconButton>
                                        </InputAdornment>
                                    ) : undefined
                            }}
                            value={searchText}
                            onChange={onSearchChange}
                        /> */}
                        <CustomDatePicker dateStart={dateStart} dateEnd={dateEnd} setDateStart={setDateStart} setDateEnd={setDateEnd} />
                    </Box>
                }
            />
            <CardContent>
                <TableContainer sx={{ height: 400 }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell>Start</TableCell>
                                <TableCell>End</TableCell>
                                <TableCell>
                                    Start <br /> Attachment
                                </TableCell>
                                <TableCell>
                                    End <br /> Attachment
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dataMileageComparison.map((item, index) => (
                                <>
                                    <TableRow key={index}>
                                        <TableCell>{item.fielder}</TableCell>
                                        <TableCell>{item.date}</TableCell>
                                        <TableCell>{item.start}</TableCell>
                                        <TableCell>{item.end}</TableCell>
                                        <TableCell>
                                            {item.startAttachment && item.startAttachment !== '' && (
                                                <IconButton
                                                    aria-label="attachment"
                                                    onClick={() => onAttachmentClicked(item.startAttachment, item.endAttachment, 0)}
                                                >
                                                    <AttachFileIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell>
                                            {item.endAttachment && item.endAttachment !== '' && (
                                                <IconButton aria-label="attachment" onClick={() => onAttachmentClicked(item.startAttachment, item.endAttachment, item.startAttachment && item.startAttachment !== '' ? 1 : 0)}>
                                                    <AttachFileIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                </>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>

            {(imageSelected !== null && imageSelectedIndex !== null) && (
                <ImagePreview
                    name={imageSelected[imageSelectedIndex].label}
                    src={imageSelected[imageSelectedIndex].url}
                    isOpen={imageSelected !== null && imageSelectedIndex !== null}
                    onClose={() => {
                        setImageSelected(null);
                        setImageSelectedIndex(null);
                    }}
                    onLeft={imageSelectedIndex > 0 ? () => setImageSelectedIndex(imageSelectedIndex - 1) : null}
                    onRight={
                        imageSelectedIndex < imageSelected.length - 1 ? () => setImageSelectedIndex(imageSelectedIndex + 1) : null
                    }
                    showName
                />
            )}

            {/*<CardActions>*/}
            {/*    <Box marginTop={2}>*/}
            {/*        <Button startIcon={<Description />} onClick={handleExportCsv}>*/}
            {/*            Export to CSV*/}
            {/*        </Button>*/}
            {/*    </Box>*/}
            {/*</CardActions>*/}
        </Card>
    );
}
